import { useCallback } from 'react';
import {
  updateCredentialAndProbe,
  loadDataCredentials,
  addCredential,
  getDataCredential,
  getCredentialUsage,
} from 'js/actions';
import { ACLQueryModeTypes } from 'js/constants/visibilityFilters';
import useAppDispatch from 'js/hooks/useAppDispatch';

export default function useCredentialsAdapter() {
  const dispatch = useAppDispatch();

  const updateCredential = useCallback((id, info, overrideActiveType = null) => {
    return dispatch(updateCredentialAndProbe(id, info, overrideActiveType));
  }, []);

  const loadCredentials = useCallback(() => {
    return dispatch(loadDataCredentials(ACLQueryModeTypes.MODE_COLLABORATOR.key));
  }, []);

  const createCredential = useCallback((type, info) => {
    return dispatch(addCredential(type, info));
  }, []);

  const wrappedGetDataCredential = useCallback(
    (id: number, config?: any) => dispatch(getDataCredential(id, config)),
    [],
  );

  const wrappedGetCredentialUsage = useCallback(
    (credentialId) => dispatch(getCredentialUsage(credentialId)),
    [],
  );

  return {
    updateCredential,
    createCredential,
    loadCredentials,
    getDataCredential: wrappedGetDataCredential,
    getCredentialUsage: wrappedGetCredentialUsage,
  };
}
